import { useEffect, useState } from 'react';

export const useReprofilingState = (initialSuggestion?: string) => {
  const [suggestion, setSuggestion] = useState<string | undefined>(undefined);
  const [selection, setSelection] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (initialSuggestion && !suggestion) {
      setSuggestion(initialSuggestion);
      setSelection(initialSuggestion);
    }
  }, [initialSuggestion, suggestion]);

  const handleSelectionChange = (newSelection: string) => {
    setSelection(newSelection);
  };

  return {
    suggestion,
    selection,
    onSelectionChange: handleSelectionChange,
  };
};
